<template>
    <div class="checkout-review">
        <span class="question">
            {{ 'checkout.checkoutReview.question' | trans }}
        </span>

        <div class="stars">
            <span class="star" @click="stars = 1" :class="{ active: stars >= 1 }">
                <i class="fas fa-star"></i>
            </span>
            <span class="star" @click="stars = 2" :class="{ active: stars >= 2 }">
                <i class="fas fa-star"></i>
            </span>
            <span class="star" @click="stars = 3" :class="{ active: stars >= 3 }">
                <i class="fas fa-star"></i>
            </span>
            <span class="star" @click="stars = 4" :class="{ active: stars >= 4 }">
                <i class="fas fa-star"></i>
            </span>
            <span class="star" @click="stars = 5" :class="{ active: stars >= 5 }">
                <i class="fas fa-star"></i>
            </span>
        </div>

        <textarea
            class="form-control"
            :placeholder="'checkout.checkoutReview.commentPlaceholder' | trans"
            v-model="comment"
            v-if="stars !== null || comment !== null"
            @change="save"></textarea>

        <!-- Loading -->
        <div class="text-center my-2" v-if="isLoading">
            <i class="fa fa-spinner fa-spin"></i>
        </div>

        <!-- Success message -->
        <p class="mt-2 text-success text-center" v-if="! isLoading && isSuccess">
            {{ 'checkout.checkoutReview.success' | trans }}
        </p>
    </div>
</template>

<script>
    export default {
        props: ['bookingToken'],
        data() {
            return {
                isLoading: false,
                isSuccess: false,
                stars: null,
                comment: null,
            }
        },
        mounted() {
            this.load()
        },
        computed: {},
        methods: {
            save() {
                var self = this;

                this.isLoading = true
                this.isSuccess = false

                axios.put(route('api.frontend.reviews.update', {
                    booking: this.bookingToken,
                }), {
                    checkout_rating: this.stars,
                    checkout_comment: this.comment,
                }).then((response) => {
                    self.isLoading = false
                    self.isSuccess = true
                }).catch((error) => {
                    self.isLoading = false
                    self.isSuccess = false
                    console.log(error);
                });
            },

            load() {
                var self = this;

                axios.get(route('api.frontend.reviews.show', {
                    booking: this.bookingToken,
                })).then((response) => {
                    if (response.data.data) {
                        self.stars = response.data.data.checkout_rating
                        self.comment = response.data.data.checkout_comment
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
        },
        watch: {
            stars() {
                this.save()
            },
        }
    }
</script>
